import React, { useRef, useEffect, useState } from 'react';
import emailjs from '@emailjs/browser';
import Navbar from '../Components/Navbar'
import bgtwo from '../images/bg4.png'
import Swal from 'sweetalert2'

import SweetAlert2 from 'react-sweetalert2';
import { withSwal } from 'react-sweetalert2';
import Footer from '../Components/Footer';


export default function Contact(props) {
   const [loading, setLoading] = useState(false)
  useEffect(() => {
    setLoading(true)
    setTimeout(() =>{
      setLoading(false)
    }, 3500)
  }, [])
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    Swal.fire({
      title: 'Success',
      html: 'Your message has been Sent<br/>We will soon reach you through your mentioned email<br/>Thank You.',
      icon: 'success',
  });

    emailjs
      .sendForm('service_tvnebkj', 'template_j7bqdm9', form.current, {
        publicKey: 'qpessANI3elz393Y6',
      })
      .then(
        () => {
          console.log('SUCCESS!');
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
  };

  return (
    <>

      <Navbar  page="contact"/>
      
<div className='cobg'>
      <div className='bg bg-white' style = {{backgroundImage: `url(${bgtwo})` }}>
        
        <div className='flex-none lg:flex mx-8 pt-32 lg:mx-auto justify-center items-center h-screen'>
            <div className="grid grid-cols-1 mb-16">
        <div className='hidden lg:block max-w-96 h-74 bg-gray-100 mt-4 rounded-md shadow-lg '> 
        
       <h1 className=' font-bold yo2 text-2xl text-center mt-3'>Contact Info</h1>  
       <section className='border border-gray-500 w-36 mt-2  mx-auto  drop-shadow-md	'></section>
       <ul className="gradient-bullet text-lg pl-6 pt-8">
       <h1>Email:</h1>
      <div className="flex"><li className='gradient-bullet'/><h1>jmmr2003@gmail.com</h1></div>
       <h1>Phone No.:</h1>
      <div className="flex"><li className='gradient-bullet'/><h1>9320811878</h1></div>
      <div className="flex"><li className='text-pink-400'/><h1>9702551626</h1></div>
      <div className="flex"><li className='text-pink-400'/><h1>9320646432</h1></div>
      </ul>

             </div>
             <div className='hidden lg:block max-w-96 h-48 bg-gray-100 mt-2 rounded-md shadow-lg '>   
        <h1 className='font-bold yo2 text-2xl text-center mt-3'>Office Address</h1>  
       <section className='border border-gray-500 w-36 mt-2  mx-auto  drop-shadow-md	'></section>
       <ul className="gradient-bullet text-lg pl-6 pt-8">
      <div className="flex"><li className='gradient-bullet'/><h1>Shop No. 2, Plot No.1, Sector 6, Godovari Park, Sanpada, Navi Mumbai - 400705</h1></div>

      </ul>
        </div>
        </div>
      <div className='bg-gray-100 mt-3 lg:ml-8  min-w-76 lg:min-w-128 rounded-md shadow-lg  mb-16'> 
       <h1 className='font-bold yo2 text-2xl text-center mt-3'>Contact Us</h1>  
       <section className='border border-gray-500 w-36 mt-2  mx-auto  drop-shadow-md	'></section>
       
       <form ref={form} onSubmit={sendEmail}>
       <label for="first_name" class="block mb-2 text-sm font-medium text-gray-900 ml-7 mt-2 ">Name</label>
       <input type="name" name="user_name" id="name" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-72 lg:min-w-96 ml-6 p-2.5 focus:ring-blue-500 " placeholder="Name" required />

       <label for="first_name" class="block mb-2 text-sm font-medium text-gray-900 ml-7 mt-1 ">Phone</label>
       <input type="number" name="user_phone" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-72 lg:min-w-96 ml-6 p-2.5 focus:ring-blue-500 " placeholder="Phone Number" required />

       
       <label for="first_name" class="block mb-2 text-sm font-medium text-gray-900 ml-7 mt-1 ">Email</label>
       <input type="email" name="user_email" id="email" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm  rounded-md focus:ring-blue-500 focus:border-blue-500 block w-72 lg:min-w-96 ml-6 p-2.5 focus:ring-blue-500 " placeholder="Email Address" required />

       <label for="message" class="block mb-2 text-sm font-medium  ml-7 mt-1  text-gray-900">Your message</label>
    <textarea id="message" name="message" rows="6" class="block  p-2.5 w-72 lg:min-w-96 text-sm  ml-7 text-gray-900 bg-gray-50 rounded-md border border-gray-300 focus:ring-blue-500 focus:border-blue-500 " placeholder="Write your message here..."></textarea>
    <button type="submit" class="m-3 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 focus:outline-none ">Submit</button>
    </form>
        </div>
      
      {/* <div className='bg-white  h-96 w-96 rounded-md shadow-lg '>      </div>
      <div className='bg-white  h-96 w-96 rounded-md shadow-lg '>      </div> */}

      </div> 
      
      <main class=" mx-auto h max-w-7xl  sm:mt-12  lg:mt-20  ">
                <div class="sm:text-center lg:text-left">
                    <h2 class=" text-2xl text-center md:text-left tracking-tight font-extrabold text-gray-900 sm:text-3xl md:text-4xl">
                    Get in touch
                    </h2>
                    <h1 className='my-1 text-center	md:text-left text-2xl tracking-tight font-extrabold text-green-600 sm:text-3xl md:text-4xl'>Our friendly team is always here to chat.</h1>

                    <section className=' border border-green-600 w-28 mt-8  float md:float-left  mx-auto  drop-shadow-md	'></section>

<div className="flex flex-col lg:grid lg:grid-cols-3 gap-10 items-center justify-center mt-20 ">
  {/* Card 1 */}
  <div className="w-full lg:w-auto min-w-72 h-64 bg-gray-100 shadow-2xl rounded-md border-2 border-transparent hover:border-yellow-200  transition duration-300 ease-in-out">
   <div className='pt-5 pl-5'><div className='w-16 h-16 p-4 bg-yellow-100/50 rounded-full ring-2 ring-gray-300 dark:ring-gray-500'><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" {...props}><defs><style>{`.cls-1{fill:#ffc247}.cls-2{fill:#ffe45c}.cls-8{fill:#f2f6fc}.cls-9{fill:#2b1505}`}</style></defs><g id="_10-Email" data-name="10-Email"><path className="cls-1" d="m57 21 .24-.24A5.944 5.944 0 0 1 59 25v28a5.944 5.944 0 0 1-1.76 4.24L57 57 36 36l-.06-.08zM3 57l-.24.24A5.944 5.944 0 0 1 1 53V25a5.944 5.944 0 0 1 1.76-4.24L3 21l21.06 14.92L24 36z"/><path className="cls-2" d="m57 57 .24.24A5.944 5.944 0 0 1 53 59H7a5.944 5.944 0 0 1-4.24-1.76L3 57l21-21 .06-.08L27 38a4.38 4.38 0 0 0 3 1 4.38 4.38 0 0 0 3-1l2.94-2.08.06.08z"/><path className="cls-2" d="M2.76 20.76A5.944 5.944 0 0 1 7 19h46a5.944 5.944 0 0 1 4.24 1.76L57 21 35.94 35.92 33 38a4.38 4.38 0 0 1-3 1 4.38 4.38 0 0 1-3-1l-2.94-2.08L3 21z"/><path className="cls-1" d="M27 42a4.38 4.38 0 0 0 3 1 4.38 4.38 0 0 0 3-1l2.94-2.08 2.33-1.65L36 36l-.06-.08L33 38a4.38 4.38 0 0 1-3 1 4.38 4.38 0 0 1-3-1l-2.94-2.08L24 36l-2.27 2.27 2.33 1.65z"/><path d="M55 55H5l-2 2-.24.24A5.944 5.944 0 0 0 7 59h46a5.944 5.944 0 0 0 4.24-1.76L57 57z" style={{ fill: '#ffda45' }}/><g style={{ opacity: 0.54 }}><path d="M13.616 19H7a5.944 5.944 0 0 0-4.24 1.76L3 21l4.862 3.444-.1-.219C9.252 20.989 11.323 19 13.616 19z" style={{ fill: '#fff' }}/></g><path d="M43 1a16 16 0 1 1-12.82 25.54A20.715 20.715 0 0 0 26 31a12.222 12.222 0 0 1 2.4-7.48A15.979 15.979 0 0 1 43 1z" style={{ fill: '#ff636e' }}/><path d="M59 17A15.984 15.984 0 0 0 36.463 2.4a15.991 15.991 0 0 1 10.074 30.2A15.992 15.992 0 0 0 59 17z" style={{ fill: '#ff475a' }}/><g id="_Group_" data-name="<Group>"><circle className="cls-8" cx="43" cy="25" r="2"/><path className="cls-8" d="M45 9v8a2 2 0 0 1-4 0V9a2 2 0 0 1 4 0z"/><path className="cls-9" d="M60 17a17 17 0 0 0-34 0c0 .336.029.667.048 1H7a7.008 7.008 0 0 0-7 7v28a7.008 7.008 0 0 0 7 7h46a7.008 7.008 0 0 0 7-7V25a7 7 0 0 0-.731-3.083A16.96 16.96 0 0 0 60 17zM43 2a15 15 0 1 1-12.021 23.943 1 1 0 0 0-1.4-.2 17.467 17.467 0 0 0-2.13 1.91 10.818 10.818 0 0 1 1.751-3.536 1 1 0 0 0 .113-1.007A14.844 14.844 0 0 1 28 17 15.017 15.017 0 0 1 43 2zM26.278 20a16.974 16.974 0 0 0 .979 3.4A13.248 13.248 0 0 0 25 31a1 1 0 0 0 1.831.556 20.859 20.859 0 0 1 3.19-3.6A16.841 16.841 0 0 0 38 33.235l-5.575 3.949a1.1 1.1 0 0 0-.117.1A3.469 3.469 0 0 1 30 38a3.478 3.478 0 0 1-2.293-.707 1.033 1.033 0 0 0-.129-.109L4.387 20.757A4.955 4.955 0 0 1 7 20zM2 25a4.959 4.959 0 0 1 .9-2.846l19.629 13.9L2.833 55.753A4.969 4.969 0 0 1 2 53zm5 33a4.969 4.969 0 0 1-2.753-.833L24.184 37.23l2.184 1.548A5.441 5.441 0 0 0 30 40a5.441 5.441 0 0 0 3.632-1.222l2.184-1.548 19.937 19.937A4.969 4.969 0 0 1 53 58zm51-33v28a4.969 4.969 0 0 1-.833 2.753L37.472 36.058l3.162-2.24A16.813 16.813 0 0 0 58 24.985z"/><path className="cls-9" d="M43 20a3 3 0 0 0 3-3V9a3 3 0 0 0-6 0v8a3 3 0 0 0 3 3zM42 9a1 1 0 0 1 2 0v8a1 1 0 0 1-2 0zM43 28a3 3 0 1 0-3-3 3 3 0 0 0 3 3zm0-4a1 1 0 1 1-1 1 1 1 0 0 1 1-1z"/></g></g></svg></div></div>

    <div>
      <h1 className='font-bold text-xl p-3 pl-5'> Email</h1>
    </div>
    <p className='text-lg mx-5'>Our friendly team is here to help.</p>
    <p className='text-lg mx-5'>jmmr2003@gmail.com</p>
  </div>

  <div className="w-full lg:w-auto min-w-72 h-64 bg-gray-100 shadow-2xl rounded-md border-2 border-transparent hover:border-green-200  transition duration-300 ease-in-out">
  <div className='pt-5 pl-5'><div className='w-16 h-16 p-4 bg-green-100/50 rounded-full ring-2 ring-gray-300 dark:ring-gray-500'>  <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title />
    <g data-name="Layer 2" id="Layer_2"><g id="Interface-Solid"><g id="interface-solid-pin-location"><circle cx="15" cy="9.57129" fill="none" r="3.42865" /><path fill="green" d="M25.31152,20.40039a1,1,0,1,0-.623,1.90039C26.97607,23.05078,28,23.94629,28,24.5c0,1.39355-5.18506,3.5-13,3.5S2,25.89355,2,24.5c0-.55371,1.02393-1.44922,3.31152-2.19922a1,1,0,1,0-.623-1.90039C.81348,21.6709,0,23.33105,0,24.5,0,28.11035,7.5459,30,15,30s15-1.88965,15-5.5C30,23.33105,29.18652,21.6709,25.31152,20.40039Z" /><path fill="green" d="M14.37549,25.78125a1.00083,1.00083,0,0,0,1.249,0c.36572-.293,8.94678-7.26074,8.94678-16.21a9.57129,9.57129,0,0,0-19.14258,0C5.42871,18.52051,14.00977,25.48828,14.37549,25.78125Zm-2.80408-16.21A3.42859,3.42859,0,1,1,15,13,3.4287,3.4287,0,0,1,11.57141,9.57129Z" /></g></g></g>
  </svg></div></div>
    <div>
      <h1 className='font-bold text-xl p-3 pl-5'>Office Address</h1>
    </div>
    <p className='text-lg mx-5'>Shop No. 2, Plot No.1, Sector 6, Godovari Park, Sanpada, Navi Mumbai - 400705</p>
  </div>

  <div className="w-full lg:w-auto min-w-72 h-64 bg-gray-100 shadow-2xl rounded-md border-2 border-transparent hover:border-red-200  transition duration-300 ease-in-out">
  <div className='pt-5 pl-5'><div className='w-16 h-16 p-4 bg-red-100/50 rounded-full ring-2 ring-gray-300 dark:ring-gray-500'><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.314 28.323" style={{ enableBackground: 'new 0 0 28.314 28.323' }} xmlSpace="preserve"><path fill="#FF6666" d="M27.728 20.384l-4.242-4.242a1.982 1.982 0 0 0-1.413-.586h-.002c-.534 0-1.036.209-1.413.586L17.83 18.97l-8.485-8.485 2.828-2.828c.78-.78.78-2.05-.001-2.83L7.929.585A1.986 1.986 0 0 0 6.516 0h-.001C5.98 0 5.478.209 5.101.587L.858 4.83C.729 4.958-.389 6.168.142 8.827c.626 3.129 3.246 7.019 7.787 11.56 6.499 6.499 10.598 7.937 12.953 7.937 1.63 0 2.426-.689 2.604-.867l4.242-4.242c.378-.378.587-.881.586-1.416 0-.534-.208-1.037-.586-1.415zm-5.656 5.658c-.028.028-3.409 2.249-12.729-7.07C-.178 9.452 2.276 6.243 2.272 6.244L6.515 2l4.243 4.244-3.535 3.535a.999.999 0 0 0 0 1.414l9.899 9.899a.999.999 0 0 0 1.414 0l3.535-3.536 4.243 4.244-4.242 4.242z" /></svg></div></div>
  
    <div>
      <h1 className='font-bold text-xl p-3 pl-5'>Phone</h1>
    </div>
    <p className='text-lg mx-5'>9320811878<br />9702551626<br />9320646432</p>
  </div>
</div>


                </div>
            </main>

        
      </div>
      
</div>

      
    </>
  )
}
